import Select from "lib/common/controls/Select";
import PropTypes from "prop-types";
import React from "react";
import Button from "../../../common/descriptorcontrols/BaseControls/Button";

/**
 * I build a histogram over the passed items, using the extractKey function to
 * assign each item to a key/bucket. The result is a Map (not an Object).
 */
function histogram(items, extractKey = it => it) {
    const buckets = new Map();
    items.forEach(it => {
        const key = extractKey(it);
        buckets.set(key, (buckets.get(key) || 0) + 1);
    });
    return buckets;
}

function Sidebar({
                     forms,
                     formKey,
                     onFormSelect,
                     allParamSets,
                     activeParamSet,
                     onParamSetSelect,
                     onParamSetRename,
                     onParamSetDelete,
                     allMembers,
                     activeMembers,
                     onActiveMembersSelect,
                 }) {
    const formOpts = React.useMemo(
        () => [ {
            key: "",
            name: "",
        } ].concat(forms),
        [ forms ],
    );
    const params = React.useMemo(() => {
        if (allParamSets && allParamSets.length > 1) {
            const names = histogram(allParamSets, it => it.name);
            if (allParamSets.length > names.size) {
                allParamSets = allParamSets.map(it => {
                    if (names.get(it.name) === 1) {
                        return it;
                    }
                    return {
                        ...it,
                        name: `${it.name} (${new Date(it.createdAt).toLocaleDateString()})`,
                    };
                });
            }
        }
        return [ {
            key: "",
            name: "",
        } ].concat(allParamSets);
    }, [ allParamSets ]);
    const members = React.useMemo(
        () => {
            if (!allMembers) return null;
            return [ {
                name: "All",
                key: "",
            } ].concat(allMembers);
        },
        [ allMembers ],
    );
    return <div className="form-section">
        <div className="form-section-inner">
            <h3>Export Type</h3>
            <Select
                className="form-control export-type-select"
                value={formKey}
                onCommitChange={onFormSelect}
                options={formOpts}
                labelKey={"name"}
                valueKey={"key"}
            />
            {allParamSets && <section className={"param-sets"}>
                <h3>Saved Parameter Selections</h3>
                <Select
                    className={"form-control param-set-select"}
                    value={activeParamSet && activeParamSet.key}
                    onCommitChange={onParamSetSelect}
                    options={params}
                    labelKey={"name"}
                    valueKey={"key"}
                />
                {activeParamSet && <div style={{display: "flex", justifyContent: "flex-end"}}>
                    {onParamSetRename && <Button
                        className={"btn btn-sm btn-link param-set-rename"}
                        label={"Rename"}
                        icon={"pencil"}
                        onClick={e => {
                            e.preventDefault();
                            onParamSetRename();
                        }}
                        enabled
                    />}
                    {onParamSetDelete && <Button
                        className={"btn btn-sm btn-link param-set-delete"}
                        label={"Delete"}
                        icon={"remove"}
                        onClick={e => {
                            e.preventDefault();
                            onParamSetDelete();
                        }}
                        enabled
                    />}
                </div>}
                {activeParamSet && !activeParamSet.canRerun && "** This selection may not have reloaded correctly."}
            </section>}
            {members && <React.Fragment>
                <h3>Data Owners</h3>
                <Select
                    className={"form-control data-owner-select"}
                    value={activeMembers || []}
                    onCommitChange={onActiveMembersSelect}
                    options={members}
                    labelKey={"name"}
                    valueKey={"key"}
                    multiple
                    size={Math.min(members.length, 8)}
                    disabled={members.length < 3}
                />
            </React.Fragment>}
        </div>
    </div>;
}

const selectListType = PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
}));
Sidebar.propTypes = {
    forms: selectListType.isRequired,
    formKey: PropTypes.string.isRequired,
    onFormSelect: PropTypes.func.isRequired,
    allParamSets: selectListType,
    activeParamSet: PropTypes.shape({
        id: PropTypes.number.isRequired,
        key: PropTypes.string.isRequired,
    }),
    onParamSetSelect: PropTypes.func,
    onParamSetRename: PropTypes.func,
    onParamSetDelete: PropTypes.func,
    allMembers: selectListType,
    activeMembers: PropTypes.arrayOf(PropTypes.string),
    onActiveMembersSelect: PropTypes.func,
};

export default Sidebar;



// WEBPACK FOOTER //
// ./app/lib/hex/views/components/Sidebar.js